import { createContext } from "react"

const UserContext = createContext({
  userIsLoggedIn: false,
  sessionIsLoading: true,
})

export default UserContext
